// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./js/product-bundles/" + {"8134":"product-bundles.bundle-accessibility.plugin","50332":"product-bundles.show-more-button.plugin"}[chunkId] + "." + {"8134":"f8f48b","50332":"99a7aa"}[chunkId] + ".js";
};